import {createAction, handleActions} from 'redux-actions';
import {Map/*, List, fromJS, setIn*/} from 'immutable';
// import {pender} from 'redux-pender';
// import * as api from 'lib/api';
// import isEmptyObject from 'is-empty-object';
import { weaponSkillList } from 'util/damageCalc';

const SET_STAT = 'items/SET_STAT';
const INIT_STAT = 'items/INIT_STAT';

export const setStat = createAction(SET_STAT);
export const initStat = createAction(INIT_STAT);

const initialState = Map({
  myStat: Map({
    con: '5',
    ski: '5',
    itemDmg: '0',
    itemCri: '0',
    achDmg: '0',
    rimtDmg: '0',
    isPara: 'N',
    isDoping: 'Y',
    weaponType: '일반',
    monSize: '소형',
    monType: '일반',
    selSkillSeq: '0'
  })
});

export default handleActions({
  [SET_STAT]: (state, action) => {
    const {name, value} = action.payload;
    
    return state.setIn(['myStat', name], value)
  },
  [INIT_STAT]: (state, action) => {
    return state.setIn(['myStat', 'selSkillSeq'], '0')
                .setIn(['myStat', 'weaponType'], '일반')
                ;
  }
}, initialState);